import React from 'react';
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  CardBody
} from "reactstrap";

import { RiBookFill } from "react-icons/ri";
import withNavigationHook from "../../hooks/withNavigationHook";
import Api from "../../components/helpers/Api";
import { updatePlaylist } from "../../components/helpers/CuratedPlaylistHelpers";
import { getSongBookPreferences } from "../../components/helpers/UserPreferenceHelpers";
import {RiEditFill} from "react-icons/ri";
import { debugLog } from "../../utils/debug";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";
import '../../the-worship-bible-2.css';

class LectionaryReadings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      activeButtonActive: false,
      readings: [],
      seasonList: null,
      preferredSongBooks: [],
      selectedTrack: 'Continuous',
      loading: true,
      collapsedReadings: {}
    };
  }

  componentDidMount() {
    const selectedLectionary = sessionStorage.getItem("selected-lectionary");

    const date = sessionStorage.getItem("selected-date");
    if (date) {
      this.setState({ loading: true });

      getSongBookPreferences().then(preferredSongBooks => {
        const songBooks = preferredSongBooks || [];
        sessionStorage.setItem("preferred-song-books", JSON.stringify(songBooks));
        this.setState({ preferredSongBooks: songBooks });
        const preferredSongBookIds = songBooks.map(songBook => songBook.id);

        Api.get('/api/lectionary')
          .then(response => {
            const lectionaries = response.data;
            const lectionary = lectionaries.find(l => l.lectionary_name === selectedLectionary);

            if (lectionary) {
              const lectionaryId = lectionary.lectionary_id;
              debugLog("[debug] lectionary id = " + lectionaryId);

              // Fetch season names for this date
              Api.get(`/api/lectionary/season/name?date=${date}&lectionaryId=${lectionaryId}`)
                  .then(response => {
                    this.setState({ seasonName: response.data });
                    debugLog("[debug] season name = " + this.state.seasonName);

                  })
                  .catch(error => {
                    console.error('Error fetching seasons:', error);
                  });

                  // Fetch readings for this date
                  Api.get(`/api/lectionary/date/${date}?lectionaryId=${lectionaryId}`)
                  .then(async response => {
                    const readingsWithSongs = await Promise.all(response.data.map(async reading => {
                      const passage = {
                        book: reading.bookName,
                        chapter: reading.chapter,
                        verseFrom: reading.verseFrom || null,
                        verseTo: reading.verseTo || null
                      };

                      try {
                        const songRes = await Api.post("/words/scripture", {
                          selectedSongBookIds: preferredSongBookIds,
                          singleScripturePassages: [passage]
                        });
                        return { ...reading, songs: songRes.data };
                      } catch (err) {
                        console.error('Failed to fetch songs for reading:', reading, err);
                        return { ...reading, songs: [] };
                      }
                    }));

                    this.setState({ readings: readingsWithSongs, loading: false });

                    debugLog("[debug] readingsWithSongs size = " + this.state.readingsWithSongs);

                  })
                  .catch(error => {
                    console.error('Error fetching readings:', error);
                    this.setState({ loading: false });
                  });
            } else {
              console.error(selectedLectionary + ' Lectionary not found');
              this.setState({ loading: false });
            }
          })
          .catch(error => {
            console.error('Error fetching lectionaries:', error);
            this.setState({ loading: false });
          });
      });
    }
  }


  isSongCuratedAlready = (songId, songBookId) => {
    const curated = !sessionStorage.getItem("curated-songs") || sessionStorage.getItem("curated-songs") === 'null' ? null : sessionStorage.getItem("curated-songs");
    if (!curated) {
      return false;
    } else {
      return JSON.parse(curated).some(item => item.key === `${songId}/${songBookId}`);
    }
  }

  updateCuratedListItem = async (event, song, songBook, index) => {
    let curated = JSON.parse(sessionStorage.getItem("curated-songs")) || [];
    const key = `${song.id}/${songBook.id}`;
    const isAlready = curated.some(item => item.key === key);

    if (!isAlready) {
      // Build comma-separated author names for display if you like:
      const authorNames = (song.authors || []).map(a => a.name);

      curated.push({
        key,
        songId: song.id,
        songTitle: song.title,
        alternativeTitle: song.alternativeTitle,
        authors: song.authors,           // << store full author objects
        authorNames: authorNames.join(", "), // << or just store a display string
        songBookId: songBook.id,
        songBookTitle: songBook.title,
        songBookSongNumber: song.wordsSongBooks[index].songBookSongNumber,
        i: curated.length + 1,
        playOrder: curated.length + 1
      });
    } else {
      curated = curated.filter(item => item.key !== key);
    }

    sessionStorage.setItem("curated-songs", JSON.stringify(curated));
    this.setState({ selectedSongCount: curated.length });

    if (sessionStorage.getItem("playlist")) {
      const playlist = JSON.parse(sessionStorage.getItem("playlist"));
      await updatePlaylist(playlist.id, playlist.name, playlist.saveNotes, curated);
    }

    sessionStorage.setItem("curatedSongsContinueEnabled", curated.length > 0);
    this.forceUpdate();
  }

  showTitle(songBook) {
    let titleToUse = songBook.title.length <= 20 ? songBook.title : !songBook.shortTitle ? songBook.title.substring(0, 19) + "..." : songBook.shortTitle;
    debugLog("[debug] using title " + titleToUse + ", title " + songBook.title + " (" + songBook.title.length + ") / shortTitle " + songBook.shortTitle);
    return <>
      {titleToUse}
    </>;
  }

  renderPreferredSongBooks = () => {
    const preferredSongBooks = this.state.preferredSongBooks || [];

    return (
        <>
          <h2 style={{fontSize: '1rem'}} className="mt-4">
            Selected song books: {preferredSongBooks.length > 0 ? "(" + preferredSongBooks.length + ")" : <></>}
          </h2>
          {preferredSongBooks.length > 0 ? (
              preferredSongBooks.map(songBook => (
                  <div className="songbook-pill" key={songBook.id}>
                    <Button
                        className="text-uppercase"
                        color="primary"
                        size="sm"
                        style={{margin: '4px'}}
                        title={songBook.title}
                    >
                      <span style={{fontSize: "0.6rem"}}>
                        {this.showTitle(songBook)}
                      </span>
                    </Button>
                  </div>
              ))
          ) : (
              <p>All song books</p>
          )}
          {sessionStorage.getItem("customer") && (
              <Button
                  color="link"
                  size="sm"
                  className="p-0 mt-2"
                  href="/your-preferences/song-books"
              >
                Change preferred song books
              </Button>
          )}
        </>
    );
  };

  toggleReading = (key) => {
    this.setState(prev => ({
      collapsedReadings: {
        ...prev.collapsedReadings,
        [key]: !prev.collapsedReadings[key]
      }
    }));
  }

  render() {
    const continueButtonEnabled = sessionStorage.getItem("curatedSongsContinueEnabled") === "true";
    const selectedDateStr = sessionStorage.getItem("selected-date");
    const readingDate = selectedDateStr ? new Date(selectedDateStr).toLocaleDateString("en-GB", {
      weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "Europe/London"
    }) : null;
    const seasonName = this.state.seasonName; //this.state.seasonList;
    const hasTrackChoice =
      this.state.readings.some(r => r.readingOption === 'Continuous') &&
      this.state.readings.some(r => r.readingOption === 'Related');
    const visibleReadings = hasTrackChoice
      ? this.state.readings.filter(
        r => r.readingOption === this.state.selectedTrack || r.readingOption === null
      )
      : this.state.readings;
    const groupedReadings = visibleReadings.reduce((groups, reading) => {
      const option = reading.readingOption || 'Default';
      if (!groups[option]) groups[option] = [];
      groups[option].push(reading);
      return groups;
    }, {});
    const setAllVisibleReadingsCollapsed = (collapsed) => {
      const updatedCollapsedReadings = Object.entries(groupedReadings).reduce((collapseState, [option, readings]) => {
        readings.forEach((reading, index) => {
          collapseState[`${option}-${index}`] = collapsed;
        });
        return collapseState;
      }, {});

      this.setState(prev => ({
        collapsedReadings: {
          ...prev.collapsedReadings,
          ...updatedCollapsedReadings
        }
      }));
    };

    return (
        <>
          <SeoNoIndex uri="/lectionary/readings" description="Find worship songs from your song books..." />

          {this.state.loading && (
              <div className="d-flex justify-content-center align-items-center" style={{
                position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.8)", zIndex: 2000
              }}>
                <div className="spinner-border text-primary" style={{ width: "3rem", height: "3rem" }} role="status" />
              </div>
          )}

          <div className="position-relative">
            <section className="section section-lg section-shaped pb-10">
              <div className="shape shape-style-1 shape-default">
                {[...Array(9)].map((_, i) => <span key={i} />)}
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows <span>{sessionStorage.getItem("selected-lectionary").toLocaleLowerCase()} readings</span>
                      </h1>
                    </Col>
                  </Row>
                </div>
              </Container>
              <div className="separator separator-bottom separator-skew">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2560 100"><polygon className="fill-white" points="2560 0 2560 100 0 100"/></svg>
              </div>
            </section>
          </div>

          <section className="section section-lg pt-lg-9">
            <Container className="mt--100">
              <Row className="justify-content-center">
                <Col lg="12">
                  <Card className="card-lift--hover shadow border-0">
                    <CardBody className="py-5">
                      <Row className="justify-content-center">
                        <Col md="3" xs="12">
                        </Col>
                        <Col md="6" xs="12">
                        </Col>
                        <Col md="3" xs="12">
                          <div className="text-center">
                          {(
                                (sessionStorage.getItem("curated-songs") && sessionStorage.getItem("curated-songs") != 'null' && JSON.parse(sessionStorage.getItem("curated-songs")).length > 0 && !sessionStorage.getItem("playlist")) ||
                                (sessionStorage.getItem("playlist") && sessionStorage.getItem("workingOnDraft") === "true")
                            ) && <>
                            <Button
                                className="btn-icon mb-3 mb-sm-0 mx-auto float-left"
                                color="primary"
                                href="/scripture/curated-songs"
                            >
                                      <span className="btn-inner--icon mr-1">
                                        <RiEditFill title="Edit" size="16"/>
                                      </span>
                                <span className="btn-inner--text">Go to song-flow</span>
                            </Button>
                          </>
                          }
                          </div>
                        </Col>
                      </Row>

                      <Row className="align-items-center">
                        <Col lg="10">
                          <h2 className="text-primary text-uppercase d-flex align-items-center"
                              style={{fontSize: '1rem'}}>
                            <div className="icon icon-shape icon-shape-primary rounded-circle">
                              <RiBookFill/>
                            </div>
                            <span className="ml-3">
                              {sessionStorage.getItem("selected-lectionary")} Readings for <strong>{seasonName}</strong> ({readingDate})
                            </span>
                          </h2>
                        </Col>

                        <Col lg="2" className="d-flex justify-content-end align-items-center">
                          <Button
                              id="goToCalendarButton"
                              className="btn-icon mb-3 mb-sm-0"
                              color="neutral"
                              onClick={() => this.props.navigation("/lectionary/choose-date")}
                          >
                            Go back to Calendar
                          </Button>
                        </Col>
                      </Row>

                      <div className="main-content-wrapper">
                        <div className="songs-content">
                          {!this.state.loading && (
                              <>
                                {hasTrackChoice && (
                                    <div className="d-flex mb-4" style={{ gap: '8px' }}>
                                      {['Continuous', 'Related'].map(track => (
                                          <Button
                                              key={track}
                                              color={this.state.selectedTrack === track ? 'primary' : 'secondary'}
                                              size="sm"
                                              onClick={() => this.setState({ selectedTrack: track })}
                                          >
                                            {track}
                                          </Button>
                                      ))}
                                    </div>
                                )}
                                {Object.keys(groupedReadings).length > 0 ? (
                                  <div className="mt-4">
                                    <div className="d-flex justify-content-end mb-3" style={{ gap: '8px' }}>
                                      <Button
                                          color="secondary"
                                          size="sm"
                                          onClick={() => setAllVisibleReadingsCollapsed(true)}
                                      >
                                        Collapse all
                                      </Button>
                                      <Button
                                          color="secondary"
                                          size="sm"
                                          onClick={() => setAllVisibleReadingsCollapsed(false)}
                                      >
                                        Expand all
                                      </Button>
                                    </div>
                                    {Object.entries(groupedReadings).map(([option, readings]) => (
                                        <div key={option} className="mb-4">
                                          {option !== 'Default' && option !== 'Continuous' && option !== 'Related' && <h5 className="text-primary mb-3">{option}</h5>}
                                          {readings.map((reading, index) => {
                                            const collapseKey = `${option}-${index}`;
                                            const isCollapsed = !!this.state.collapsedReadings[collapseKey];
                                            return (
                                              <div key={index} className="border rounded p-3 mb-2"
                                                   style={{backgroundColor: "#f8f9fa"}}>
                                                <div
                                                    className="d-flex justify-content-between align-items-center"
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => this.toggleReading(collapseKey)}
                                                >
                                                  <p className="text-primary mb-0">{this.displayScripturePassage(reading)}: {reading.typeName}</p>
                                                  <span style={{fontSize: '0.85rem', color: '#6c757d', userSelect: 'none'}}>
                                                    {isCollapsed ? 'Expand ▸' : 'Collapse ▾'}
                                                  </span>
                                                </div>
                                                {!isCollapsed && (
                                                    <>
                                                      <p className="mb-1 mt-2">
                                                        {/*{reading.notes && <p className="text-muted mb-2"*/}
                                                        {/*                     style={{fontSize: "0.85rem"}}>{reading.notes} {reading.readingOption ? <>/ {reading.readingOption}</> : <></>}</p>}*/}
                                                        {!reading.songs || reading.songs.length === 0 ?
                                                            // <>No songs found for {this.displayScripturePassage(reading)}
                                                            <>No songs found in the selected song books for&nbsp;</>
                                                            : <></>
                                                        }

                                                      </p>
                                                      {reading.songs && reading.songs.length > 0 && (
                                                    <div className="mt-2">
                                                      <div className="sortable-list" style={{width: '100%'}}>
                                                        {reading.songs && reading.songs.length > 0 && (
                                                            <div className="mt-2">
                                                              <div className="sortable-list" style={{width: '100%'}}>
                                                                {[...reading.songs]
                                                                  .sort((a, b) => a.title.localeCompare(b.title))
                                                                  .map((song, i) => {

                                                              const authorLine = (song.authors || []).map(a => a.name).join(', ');
                                                              return (
                                                              <div
                                                                    key={song.id || i}
                                                                    className={`item ${song === this.state.draggingItem ? 'dragging' : ''}`}
                                                                    draggable="false"
                                                                    // onDragStart={(e) => this.handleDragStart(e, song)}
                                                                    // onDragEnd={this.handleDragEnd}
                                                                    // onDragOver={this.handleDragOver}
                                                                    // onDrop={(e) => this.handleDrop(e, song)}
                                                                >
                                                                  <div
                                                                      className="align-items-start col-md-12 col-xs-12 row">
                                                                    {/* Title + optional alt-title */}
                                                                    <div className="col-md-5 col-xs-12" style={{fontWeight: "bold"}}>
                                                                      {song.title}
                                                                      {song.alternativeTitle && (
                                                                          <>
                                                                            <br/>({song.alternativeTitle})
                                                                          </>
                                                                      )}

                                                                      {/* ← Authors line */}
                                                                      {authorLine && (
                                                                          <div style={{
                                                                            fontWeight: 'normal',
                                                                            fontSize: '0.85rem',
                                                                            color: '#555',
                                                                            marginTop: '0.25rem'
                                                                          }}>
                                                                            {authorLine}
                                                                          </div>
                                                                      )}
                                                                    </div>

                                                                    <div className="col-md-4 col-xs-12">
                                                                      {song.wordsSongBooks && song.wordsSongBooks.map((wsb, idx) => (
                                                                          <div key={idx}>
                                                                            {/*{wsb.songBook?.title} ({wsb.songBookSongNumber})*/}
                                                                            <div className="col-md-2 col-xs-12">
                                                                              <div className="col-md-7 col-xs-12 mb-1 ml--5"
                                                                                   key={wsb.songBook.id}>
                                                                                <label className="custom-toggle ml-3"
                                                                                       style={{marginBottom: "-30px"}}>
                                                                                  {/*<input*/}
                                                                                  {/*    className="custom-control-input"*/}
                                                                                  {/*    id={song.id + "/" + wsb.songBook.id}*/}
                                                                                  {/*    name={song.id + "/" + wsb.songBook.id}*/}
                                                                                  {/*    onClick={(e) => this.updateCuratedListItem(e, song, wsb.songBook, idx)}*/}
                                                                                  {/*    checked={this.isSongCuratedAlready(song.id, wsb.songBook.id) ? "checked" : ""}*/}
                                                                                  {/*    type="radio"*/}
                                                                                  {/*/>*/}
                                                                                  <input
                                                                                      type="checkbox"
                                                                                      className="custom-control-input"
                                                                                      id={`${song.id}/${wsb.songBook.id}/${idx}`} // make id unique
                                                                                      name={`${song.id}/${wsb.songBook.id}`}
                                                                                      checked={this.isSongCuratedAlready(song.id, wsb.songBook.id)}
                                                                                      onChange={(e) => this.updateCuratedListItem(e, song, wsb.songBook, idx)}
                                                                                  />
                                                                                  <span
                                                                                      className="custom-toggle-slider rounded-circle"/>
                                                                                  <span className="ml-6"
                                                                                        style={{whiteSpace: "nowrap"}}>
                                                                                    {this.showTitle(wsb.songBook)}&nbsp;
                                                                                    ({wsb.songBookSongNumber})
                                                                                  </span>
                                                                                </label>
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                      ))}
                                                                    </div>

                                                                  </div>
                                                                </div>
                                                                )})}
                                                              </div>
                                                            </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                      )}
                                                    </>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                    ))}
                                  </div>
                                ) : (
                                  <p className="mt-3">No readings found for this date.</p>
                                )}
                              </>
                          )}
                        </div>
                        <div className="pills-sidebar">
                          {this.renderPreferredSongBooks()}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <div style={{
                position: "fixed", bottom: "0", left: "0", width: "100%", backgroundColor: "white",
                padding: "40px", boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)", zIndex: "1000"
              }}>
                <div className="col-md-12" style={{position: "fixed", bottom: "20px", right: "0px", zIndex: "1000"}}>
                  <Button block color="primary" href="/lectionary/curated-songs"
                          disabled={!continueButtonEnabled}>
                    <span className="btn-inner--text">Curate Song-flow</span>
                  </Button>
                </div>
              </div>
            </Container>
          </section>
        </>
    );
  }

  displayScripturePassage(reading) {
    return <>
      <strong>{reading.bookName}</strong> {reading.chapter}
      {reading.verseFrom && `:${reading.verseFrom}`}
      {reading.verseTo && `-${reading.verseTo}`}
    </>;
  }
}

export default withNavigationHook(LectionaryReadings);
